import { FetchError } from "common/types/fetchError";
import { getFetchHeaders } from "lib/utils/fetchAuthHelpers";

export async function authGet<T>(url: string): Promise<T> {
  const headers = await getFetchHeaders(true);
  const res = await fetch(url, { headers });
  if (!res.ok) {
    throw new FetchError(res.status, res.statusText);
  }
  return res.json();
}

export async function authPost<TBody, TRes>(url: string, body: TBody): Promise<TRes> {
  const headers = await getFetchHeaders(true);
  const res = await fetch(url, { method: "POST", headers, body: JSON.stringify(body) });
  if (!res.ok) {
    throw new FetchError(res.status, res.statusText);
  }
  return res.json();
}

export async function authPut<TBody, TRes>(url: string, body: TBody): Promise<TRes> {
  const headers = await getFetchHeaders(true);
  const res = await fetch(url, { method: "PUT", headers, body: JSON.stringify(body) });
  if (!res.ok) {
    throw new FetchError(res.status, res.statusText);
  }
  return res.json();
}

export async function authDelete(url: string): Promise<void> {
  const headers = await getFetchHeaders(true);
  const res = await fetch(url, { method: "DELETE", headers });
  if (!res.ok) {
    throw new FetchError(res.status, res.statusText);
  }
}
